import { useRevealHiddenReadOnlyFields } from "./RevealHiddenReadOnlyFieldsContext";

// Read-only fields (flagged by the server, ex: FranceConnect pivot identity
// data) can never be edited. They stay hidden like any other hidden field,
// except on surfaces opting into RevealHiddenReadOnlyFieldsContext (the
// profile edition page), so users only see them where their full profile is
// reviewed.
export const useReadOnlyFieldProps = formField => {
  const revealHiddenReadOnlyFields = useRevealHiddenReadOnlyFields();
  const { readOnly, hide } = formField;

  if (!readOnly) {
    return { hide, disabled: false };
  }

  return {
    hide: revealHiddenReadOnlyFields ? false : hide,
    disabled: true
  };
};
